import withSplitting from './withSplitting';

export const Online = withSplitting(() => import('./Online'));
export const Analysis = withSplitting(() => import('./Analysis'));
export const Category = withSplitting(() => import('./Category'));
export const OtherContents = withSplitting(() => import('./OtherContents'));
export const Keyword = withSplitting(() => import('./Keyword'));


